import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import LabelAndValueUI from '../../../widgets/layout/LabelAndValueUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import ButtonTinyWithSpinnerUI from '../../../widgets/action/ButtonTinyWithSpinnerUI'
import FileUploadModalSF from '../../../widgets/form/FileUploadModalSF'
import EmptyListUI from '../../../widgets/output/EmptyListUI'

// The PendingMessageApprovalListUI component
const PendingMessageApprovalListUI = ({ messages, selectedMessageId, onUpdateMessageClick,
  sendSubmitted, sendSuccessMsg, sendErrorList, onSendClick,
  deleteSubmitted, deleteSuccessMsg, deleteErrorList, onDeleteClick, context,
  internalSendSubmitted, internalSendSuccessMsg, internalSendErrorList, onSendNoticeToInternalClick,
  onDocsUploadClick, uploadSubmitted, uploadSuccessMsg, uploadErrorList,
  docsUploadMode, onDocsUploadCancel, onDocsUpload, deleteFileMode, selectedFile, onFileDeleteClick, onDocDownloadClick,
  onAddEmailClick, onUpdateEmailClick, onDeleteEmailClick
}) => {
  return (
    <>
      {
        messages.length > 0 ? (
          messages.map((message, i) => (
            <div key={i}>
              <CardUI>
                <div className='g_flex_h g_flex_top g_flex_left'>
                  <LabelAndValueUI label='Email Recipients'>
                    {
                      message.emailToList.map((email, j) => (
                        <div key={j} className="g_flex_h g_flex_center g_m_bottom_10">
                          <span className="g_flex_v">{email}</span>
                          <span
                            className="icon icon-pencil g_m_left_10"
                            onClick={onUpdateEmailClick}
                            data-message-approval-id={message.messageApprovalId}
                            data-selected-email={email}
                          />
                          <span
                            className="icon icon-trash-o g_m_left_10"
                            data-message-id={message.messageApprovalId}
                            data-email={email}
                            onClick={onDeleteEmailClick}
                          />
                        </div>
                      ))
                    }
                  </LabelAndValueUI>
                  <span className='g_m_right_100' />
                  <span className='g_m_right_100' />
                  <LabelAndValueUI label='File Attachments'>
                    {
                      message.fileUploadList.map((file, j) =>
                        <span key={j} className='g_flex_h g_flex_left'>
                          <Link className='g_m_right_50' onClick={onDocDownloadClick} to='#' message-approval-id={message.messageApprovalId} data-file-name={file}>
                            {file}
                          </Link>
                          <span className='icon icon-trash-o g_m_left_50' onClick={onFileDeleteClick}
                            data-message-id={message.messageApprovalId} data-file-name={file} />
                          <SpinnerUI show={selectedFile === file && deleteFileMode} />
                        </span>
                      )}
                  </LabelAndValueUI>
                </div>
              </CardUI>
              <LRTableBodyUI>
                <LRTableRowUI className='g_flex_top'
                  left={<RowLeftUI message={message} />}
                  right={<RowRightUI message={message} selectedMessageId={selectedMessageId} onUpdateMessageClick={onUpdateMessageClick}
                    sendSubmitted={sendSubmitted} sendSuccessMsg={sendSuccessMsg} sendErrorList={sendErrorList} onSendClick={onSendClick}
                    deleteSubmitted={deleteSubmitted} deleteSuccessMsg={deleteSuccessMsg} deleteErrorList={deleteErrorList}
                    onDeleteClick={onDeleteClick} context={context}
                    onSendNoticeToInternalClick={onSendNoticeToInternalClick}
                    internalSendSubmitted={internalSendSubmitted}
                    internalSendSuccessMsg={internalSendSuccessMsg}
                    internalSendErrorList={internalSendErrorList}
                    onDocsUploadClick={onDocsUploadClick}
                    onAddEmailClick={onAddEmailClick}
                    uploadSubmitted={uploadSubmitted}
                    uploadSuccessMsg={uploadSuccessMsg}
                    uploadErrorList={uploadErrorList}
                  />}
                />
              </LRTableBodyUI>
            </div >
          ))
        ) : (<EmptyListUI
          context={context}
          createDisabledMessageLabel='No Message Approvals'
        />
        )
      }
      {
        docsUploadMode && (
          <FileUploadModalSF
            context={context}
            titleLabel='Upload Document'
            uploadMode={docsUploadMode}
            onCancelClick={onDocsUploadCancel}
            signedUrlApi={`/api/su/messages/approvals/${selectedMessageId}/fileUploadSignedUrl`}
            onUpload={onDocsUpload}
          />
        )
      }
    </>
  )
}

// RowLeftUI component to display message details
const RowLeftUI = ({ message }) => (
  <div>
    Subject: {message.emailSubject}<br />
    <span dangerouslySetInnerHTML={{ __html: message.message }} />
  </div>
)

const RowRightUI = ({ message, selectedMessageId, updateSubmitted, updateSuccessMsg,
  updateErrorList, onUpdateMessageClick, deleteSubmitted, deleteSuccessMsg, deleteErrorList,
  onDeleteClick, sendSubmitted, sendSuccessMsg, sendErrorList, onSendClick, context,
  onDocsUploadClick, uploadSubmitted, uploadSuccessMsg, uploadErrorList,
  onSendNoticeToInternalClick, internalSendSubmitted, internalSendSuccessMsg, internalSendErrorList,
  onAddEmailClick
}) =>
  <div className='g_text_right'>
    <div className='g_flex_v'>
      {/* Edit (pencil) icon */}
      <span
        className='icon icon-pencil'
        onClick={onUpdateMessageClick}
        message-approval-id={message.messageApprovalId}
      />
      <Link to='#' className='g_m_left_50' message-approval-id={message.messageApprovalId}
        onClick={onAddEmailClick}>
        Add Email
      </Link>
    </div>
    {/* Notice To Internal Team Button */}
    {context.permissions.includes('su_manage') &&
      <ButtonTinyWithSpinnerUI
        label='Send Notice To Internal'
        rowId={message.messageApprovalId}
        onClick={onSendNoticeToInternalClick}
        alignLeft={false}
        busy={selectedMessageId === message.messageApprovalId && internalSendSubmitted}
        successMsg={selectedMessageId === message.messageApprovalId && internalSendSuccessMsg}
        errorList={selectedMessageId === message.messageApprovalId && internalSendErrorList}
      />
    }

    {/* Send Button */}
    {context.permissions.includes('su_manage') && (
      <ButtonTinyWithSpinnerUI
        label='Send Notice To Client'
        rowId={message.messageApprovalId}
        onClick={onSendClick}
        alignLeft={false}
        busy={selectedMessageId === message.messageApprovalId && sendSubmitted}
        successMsg={selectedMessageId === message.messageApprovalId && sendSuccessMsg}
        errorList={selectedMessageId === message.messageApprovalId && sendErrorList}
      />
    )}
    {/* Delete Button */}
    {
      <ButtonTinyWithSpinnerUI
        label='Delete'
        rowId={message.messageApprovalId}
        onClick={onDeleteClick}
        alignLeft={false}
        busy={selectedMessageId === message.messageApprovalId && deleteSubmitted}
        successMsg={selectedMessageId === message.messageApprovalId && deleteSuccessMsg}
        errorList={selectedMessageId === message.messageApprovalId && deleteErrorList}
      />
    }
    <Link to='#' className='g_m_left_50' message-approval-id={message.messageApprovalId}
      onClick={onDocsUploadClick}>
      Upload
    </Link>

  </div>

export default PendingMessageApprovalListUI
